module.exports = __webpack_public_path__ + "assets/img/thumb_ch1_news-item-0.eecbaa4e.jpg";